import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const SerieDocumentoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='SERIE' htmlFor='filtro-serieDocumento' xs={4} xl={5} alignRightAt='xs' />
      <Col xs={8} xl={7}>
        <Field name='serieDocumento'>
          {({ field }) => <Form.InputText {...field} id='filtro-serieDocumento' isInvalid={iTouched && iError} disabled={fIsSubmitting} />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(SerieDocumentoFormGroup)
